export enum PendingResourcePaymentOriginEnum {
  web = 1,
  app = 2,
  myClub = 3,
  kiosk = 4
}
